import React from 'react';
import OptimizedImage from './OptimizedImage';
import ForensicGauge from '../custom-widgets/ForensicGauge';
import RatingCircle from '../custom-widgets/RatingCircle';
import SeasonSparkline from '../custom-widgets/SeasonSparkline';
import ComparisonBars from '../custom-widgets/ComparisonBars';
import PositionalGrid from '../custom-widgets/PositionalGrid';
import { PerformanceDetailIcon, GaugeIcon, PerformanceIcon } from '../custom-widgets/IconAssets';
import styles from './MobileProfile.module.css';

const MobileProfile = ({
    player,
    isMember,
    positionStats,
    positionalMetrics,
    trendData,
    comparisonValueItems,
    comparisonRatingItems,
    articles
}) => {
    const highestValue = comparisonValueItems?.length
        ? Math.round(Math.max(...comparisonValueItems.map(item => item.value)))
        : 100;
    return (
        <>
            <div className={`${styles['locked-container']} ${styles['content-reveal']} ${!isMember ? styles['blurred-content-locked'] : ''}`}>
                {/* 1. Forensic Gauge */}
                <section className={`${styles['content-section']} ${styles['gauge-section']}`}>
                    <div className={styles['content-card']}>
                        <div className={styles['card-header']} style={{ justifyContent: 'space-between' }}>
                            <span>Forensic Value Gauge</span>
                            <PerformanceDetailIcon width={18} height={18} style={{ opacity: 0.6 }} />
                        </div>
                        <ForensicGauge
                            value={player.base_value}
                            forcedValue={player.forced_sale_value}
                            premiumValue={player.premium_value}
                            isMember={isMember}
                        />
                    </div>
                </section>

                <div className={styles['section-rule']} />
                <h2 className={styles['section-title']}>Performance <span>Intelligence</span></h2>

                {/* 2. Rating & Positional Stats */}
                <section className={`${styles['content-section']} ${styles['rating-section']}`} style={{ marginTop: '12px' }}>
                    <h3 className={styles['form-subtitle']}>Current Form</h3>
                    <div className={styles['content-card']}>
                        <div className={styles['card-header']} style={{ justifyContent: 'space-between' }}>
                            <span>Performance Rating</span>
                            <PerformanceDetailIcon width={18} height={18} style={{ opacity: 0.6 }} />
                        </div>
                        <div className={styles['rating-wrap']} style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', paddingTop: '2rem' }}>
                            <RatingCircle rating={positionStats?.rating || 0} />
                        </div>
                    </div>
                </section>

                <section className={`${styles['content-section']} ${styles['stats-section']}`}>
                    <h3 className={styles['form-subtitle']}>Positional Stats</h3>
                    <PositionalGrid metrics={positionalMetrics} />
                </section>

                {/* 3. Sparkline */}
                <section className={`${styles['content-section']} ${styles['sparkline-section']}`}>
                    <div className={styles['section-header-outside']}>
                        <span>Season Momentum Sparkline</span>
                        <GaugeIcon width={18} height={18} style={{ opacity: 0.6 }} />
                    </div>
                    <div className={styles['content-card']}>
                        <SeasonSparkline data={trendData} isMember={true} />
                    </div>
                </section>

                {/* 4. Comparisons */}
                <section className={`${styles['content-section']} ${styles['comparison-card-section']}`}>
                    <div className={styles['section-header-outside']}>
                        <span>Forensic Value Comparison</span>
                        <GaugeIcon width={20} height={20} style={{ opacity: 0.8 }} />
                    </div>
                    <div className={styles['content-card']}>
                        <ComparisonBars
                            title=""
                            items={comparisonValueItems}
                            maxValue={highestValue}
                            unit="£"
                            suffix="M"
                        />
                    </div>
                </section>

                <section className={`${styles['content-section']} ${styles['comparison-card-section']}`}>
                    <div className={styles['section-header-outside']}>
                        <span>Performance Rating Comparison</span>
                        <PerformanceIcon width={20} height={20} style={{ opacity: 0.8 }} />
                    </div>
                    <div className={styles['content-card']}>
                        <ComparisonBars
                            title=""
                            items={comparisonRatingItems}
                            maxValue={10}
                            rating={true}
                        />
                    </div>
                </section>
            </div>

            {/* 5. Articles */}
            {articles && articles.length > 0 && (
                <section className={`${styles['content-section']} ${styles['articles-section']}`}>
                    <h2 className={styles['articles-title']}>Articles</h2>
                    <div className={styles['content-card']}>
                        <div className={styles['card-header']}>
                            <span>Latest Articles</span>
                        </div>
                        <div className={styles['news-list']}>
                            {articles.map(article => (
                                <a
                                    key={article.id}
                                    href={article.url}
                                    target="_blank"
                                    rel="noopener"
                                    className={styles['news-card']}
                                >
                                    <OptimizedImage
                                        src={article.thumbnail}
                                        fallbackSrc={"/player/fallback.png"}
                                        alt=""
                                        width={120}
                                        height={80}
                                        unoptimized
                                        className={styles['news-thumb']}
                                    />
                                    <div className={styles['news-content']}>
                                        <span className={styles['news-category']}>{article.category}</span>
                                        <h4 className={styles['news-headline']}>{article.headline}</h4>
                                        <span className={styles['news-date']}>{article.date}</span>
                                    </div>
                                </a>
                            ))}
                        </div>
                    </div>
                </section>
            )}
        </>
    );
};

export default MobileProfile;
